module.exports = __webpack_public_path__ + "img/electronic_use.b8cdf775.svg";